export enum Country {
    GB = 'GB',
    US = 'US',
}
